import { useEffect, useRef } from "react"

export const useTrackingCode = (trackingCodeHtml: string | null | undefined) => {
  const hasExecutedRef = useRef(false)
  const insertedElementsRef = useRef<Array<HTMLElement>>([])

  useEffect(() => {
    if (!trackingCodeHtml || hasExecutedRef.current) {
      return
    }

    hasExecutedRef.current = true
    const insertedElements: Array<HTMLElement> = []

    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(trackingCodeHtml, "text/html")

      const scriptElements = doc.querySelectorAll("script")
      const bodyChildren = Array.from(doc.body.children)

      scriptElements.forEach((originalScript) => {
        const newScript = document.createElement("script")

        Array.from(originalScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value)
        })

        if (!originalScript.src) {
          newScript.textContent = originalScript.textContent
        }

        newScript.onerror = () => {}

        document.body.appendChild(newScript)
        insertedElements.push(newScript)
      })

      const nonScriptElements = bodyChildren.filter(
        (element) => element.tagName.toLowerCase() !== "script"
      )

      if (nonScriptElements.length > 0) {
        const container = document.createElement("div")
        container.style.display = "none"

        nonScriptElements.forEach((element) => {
          container.appendChild(element.cloneNode(true))
        })

        if (container.children.length > 0) {
          document.body.appendChild(container)
          insertedElements.push(container)
        }
      }

      insertedElementsRef.current = insertedElements
    } catch (error) {
      console.error("Failed to parse tracking code:", error)
    }

    return () => {
      insertedElementsRef.current.forEach((element) => {
        element.remove()
      })
      insertedElementsRef.current = []
      hasExecutedRef.current = false
    }
  }, [trackingCodeHtml])
}
